import { defineMessages } from "react-intl";

// Override tenant-specific values in "ploy-ui/tenants/src/translations/<lang>.json"

export default defineMessages({
	// GENERIC Fields:
	"Generic.HouseholdInfo": {
		id: "helperTexts.Generic.HouseholdInfo",
		defaultMessage: "Helpertext from frontend translation resource",
		description: "Customer helperText for 'Generic.HouseholdInfo'"
	}
});
